import AlertPopup from "../../molecule/AlertPopup";
import CommonModalPopup from "../CommonModalPopup";
import { useMobileOrientation } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { isMobileView } from "../../../utilities/deviceUtilities";

export default function Footer() {

    const { isLandscape } = useMobileOrientation();
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const isLandscapeViewEnabled = sessionStorage?.getItem("showLandscapeView") === "true" ? true : false;
    const navigate = useNavigate();
    const isPhone = isMobileView()

    const handleUnsubscribeAction = () => {
        navigate("/?redirect_url=/notification");
    }

    useEffect(() => {
        if (searchParams.get("action") === "unsubscribe") {
            setTimeout(() => { setShowModal(true) }, 1500)
        }
    }, [])

    return (
        <footer>
            <AlertPopup />
            {isPhone && isLandscape && !isLandscapeViewEnabled && <CommonModalPopup
                type="warning"
                show={true}
                title=" " // blank string needed here
                body={t("landscapeView")}
                confirm={{ title: t("OK"), handler: () => { sessionStorage?.setItem("showLandscapeView", "true") } }}
                close={{}}
            />}

            {showModal && <CommonModalPopup
                type="warning"
                show={true}
                title={t("unsubscribeModalTitle")}
                body={t("unsubscribeModalBody")}
                confirm={{ title: t("Yes"), handler: () => { handleUnsubscribeAction() } }}
            />}
        </footer>
    )
}